import React from 'react';
import { formatDate, formatUSDT } from '../../utils/format';
import { ACTIVITY_TYPE, ACTIVITY_ICON } from '../../utils/constants';
import { ethers } from 'ethers';
import './Activity.css';

export default function ActivityLog({ activities }) {
  if (!activities || !activities.length) {
    return (
      <div className="empty-state">
        <div className="icon">📜</div>
        <h4 style={{ marginBottom: 8 }}>No activity yet</h4>
        <p>Your recent actions will appear here.</p>
      </div>
    );
  }

  return (
    <div className="activity-list">
      {activities.map((a, i) => {
        const type = Number(a.activityType);
        const amount = ethers.BigNumber.from(a.amountUSDT);
        return (
          <div key={i} className="activity-item">
            <div className="activity-icon">{ACTIVITY_ICON[type] || '•'}</div>
            <div className="activity-info">
              <div className="type">{ACTIVITY_TYPE[type] || 'Activity'}</div>
              <div className="date">{formatDate(a.timestamp)}</div>
            </div>
            <div className="activity-amount">
              {amount.gt(0) ? formatUSDT(amount) + ' USDT' : '—'}
            </div>
          </div>
        );
      })}
    </div>
  );
}
